import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const AnnouncementMultiImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '341_309_568',
    width: 568,
    height: 516,
    ratio: 1.1,
  },
  {
    screen: Screen.XS,
    key: '341_309_768',
    width: 768,
    height: 698,
    ratio: 1.1,
  },
  {
    screen: Screen.SM,
    key: '533_240_1024',
    width: 1024,
    height: 461,
    ratio: 2.22,
  },
  {
    screen: Screen.MD,
    key: '533_240_1366',
    width: 1366,
    height: 615,
    ratio: 2.22,
  },
  {
    screen: Screen.LG,
    key: '900_259_1600',
    width: 1600,
    height: 461,
    ratio: 3.47,
  },
  {
    screen: Screen.XL,
    key: '900_259_1920',
    width: 1920,
    height: 553,
    ratio: 3.47,
  },
];
